import React from 'react';
import { DiaryEntry } from './DiaryEntry';
import { CTAButton } from './CTAButton';
const entries = [{
  date: '12. Januar 2026',
  title: 'Der Schock',
  content: <>
        <strong className="text-gray-900 font-bold" data-id="element-49">
          Rex hörte auf zu fressen. Würgte. Sein Bauch war hart.
        </strong>{' '}
        Notaufnahme beim Tierarzt. Röntgen: ein Stück Spielzeug. Operation. Ich
        saß vier Stunden im Wartezimmer und betete. Er hat es geschafft.
      </>
}, {
  date: '23. Januar 2026',
  title: 'Die Erholung',
  content: <>
        Rex kommt nach Hause. Der Darm ist geschwächt. Schonkost. Wenig
        Bewegung. Der Tierarzt empfiehlt sanfte Unterstützung für die Darmflora.
        Ich recherchiere. Ich hatte schon so viele Sachen ausprobiert — aber
        dann sah ich, dass fast 900 andere Hundehalter das Topping bewertet
        hatten, viele mit genau denselben Problemen wie Rex.{' '}
        <strong className="text-gray-900 font-bold" data-id="element-50">
          Ich finde ein pflanzliches Topping mit Präbiotika und schützenden
          Ballaststoffen.
        </strong>
      </>
}, {
  date: '12. Februar 2026',
  title: 'Der Wiederaufbau',
  content: <>
        Ich schleiche das Topping ganz langsam ein. Winzige Mengen zunächst.{' '}
        <strong className="text-gray-900 font-bold" data-id="element-51">
          Rex' Verdauung stabilisiert sich und er frisst endlich wieder mit
          Appetit.
        </strong>{' '}
        Der Stuhl normalisiert sich. Sein Bauch entspannt sich.
      </>
}, {
  date: '8. März 2026',
  title: 'Heute',
  content: <>
        Rex ist wieder er selbst. Das Topping bleibt – als tägliche Vorsorge
        damit sein Darm stark und geschützt bleibt. Ich gebe es ihm nun
        dauerhaft. Nach diesem Erlebnis nehme ich Darmgesundheit sehr ernst.
      </>
}];
export function DiarySection() {
  return <section className="w-full py-12 px-4 md:px-8 max-w-3xl mx-auto relative" data-id="element-52">
      <div className="absolute left-8 md:left-12 top-24 bottom-12 w-px bg-warm-brown/20 hidden md:block" data-id="element-53" />

      <div className="space-y-12" data-id="element-54">
        {/* Entry 1: Der Schock */}
        <div className="relative" data-id="element-55">
          <div className="absolute -left-5 md:-left-[21px] top-8 w-3 h-3 rounded-full bg-forest-green hidden md:block border-4 border-cream box-content" data-id="element-56" />
          <DiaryEntry index={0} date={entries[0].date} title={entries[0].title} content={entries[0].content} data-id="element-57" />
        </div>

        {/* Entry 2: Die Erholung */}
        <div className="relative" data-id="element-58">
          <div className="absolute -left-5 md:-left-[21px] top-8 w-3 h-3 rounded-full bg-forest-green hidden md:block border-4 border-cream box-content" data-id="element-59" />
          <DiaryEntry index={1} date={entries[1].date} title={entries[1].title} content={entries[1].content} data-id="element-60" />
        </div>

        {/* Pull Quote after Die Erholung */}
        <div className="py-8 px-4 text-center relative" data-id="element-61">
          <span className="absolute top-0 left-1/2 -translate-x-1/2 text-6xl text-warm-brown/20 font-serif leading-none" data-id="element-62">
            "
          </span>
          <p className="text-xl md:text-2xl italic font-serif text-gray-800 relative z-10 mt-4" data-id="element-63">
            Wenn man verzweifelt ist, greift man nach jedem Strohhalm, um seinem
            Hund zu helfen.
          </p>
        </div>

        {/* Entry 3: Der Wiederaufbau */}
        <div className="relative" data-id="element-64">
          <div className="absolute -left-5 md:-left-[21px] top-8 w-3 h-3 rounded-full bg-forest-green hidden md:block border-4 border-cream box-content" data-id="element-65" />
          <DiaryEntry index={2} date={entries[2].date} title={entries[2].title} content={entries[2].content} data-id="element-66" />
        </div>

        {/* CTA #1 after Der Wiederaufbau */}
        <div className="py-4 flex justify-center" data-id="element-67">
          <CTAButton label="Das Topping das Rex geholfen hat → hier testen" position="story_cta" data-id="element-68" />
        </div>

        {/* Entry 4: Heute */}
        <div className="relative" data-id="element-69">
          <div className="absolute -left-5 md:-left-[21px] top-8 w-3 h-3 rounded-full bg-forest-green hidden md:block border-4 border-cream box-content" data-id="element-70" />
          <DiaryEntry index={3} date={entries[3].date} title={entries[3].title} content={entries[3].content} data-id="element-71" />
        </div>
      </div>
    </section>;
}